import { NgModule } from '@angular/core';
import { AppFormComponent } from './form-test/app-form.component';
import { SimpleFileUploaderModule } from '../simple-file-uploader/simple-file-uploader.module';
import { FormQuestion } from './form-question.directive';
import { SharedModule } from '../../shared/shared.module';
import { AppFormService } from './app-form.service';


@NgModule({
    imports: [
        SharedModule,
        SimpleFileUploaderModule,
    ],
    exports: [
        AppFormComponent,
    ],
    declarations: [
        AppFormComponent,
        FormQuestion,
    ],
    providers: [
        AppFormService,
    ],
})
export class AppFormModule {
}
